<template>
  <div>
    <v-card light>
      <v-card-title class="headline">
        ¿Está seguro que desea borrar: {{ item }}?
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDialog"
          >Cancel</v-btn
        >
        <v-btn color="red darken-1" text @click="save"
          >Borrar</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "dialog-delete-items",
  props: ["item"],
  data: function() {
      return {

      }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    save() {
      this.$emit("saveDialog");
    },
  },
};
</script>
<style>
</style>